
import { URLS } from '../constants'
import {
    GET_ALL_ACCESS_KEYS_BEGIN, GET_ALL_ACCESS_KEYS_SUCCESS, GET_ALL_ACCESS_KEYS_FAILURE,
    GET_ACCESS_KEY_BEGIN, GET_ACCESS_KEY_SUCCESS, GET_ACCESS_KEY_FAILURE,
    POST_ACCESS_KEY_BEGIN, POST_ACCESS_KEY_SUCCESS, POST_ACCESS_KEY_FAILURE,
    PUT_ACCESS_KEY_BEGIN, PUT_ACCESS_KEY_SUCCESS, PUT_ACCESS_KEY_FAILURE
} from '../constants/ActionTypes'

import { dispatchFetchGet, dispatchFetchPost, dispatchFetchPut } from './ActionUtil'

// Get All Access Keys
const acGetAllAccessKeysBegin = () => ({ type: GET_ALL_ACCESS_KEYS_BEGIN })
const acGetAllAccessKeysSuccess = data => ({ type: GET_ALL_ACCESS_KEYS_SUCCESS, payload: data })
const acGetAllAccessKeysFailure = err => ({ type: GET_ALL_ACCESS_KEYS_FAILURE, payload: err })

/**
 * @description Retrieves all access keys.
 *
 * @author Maria Eduarda Franke
 */
export const acGetAllAccessKeys = () => {
    return dispatchFetchGet(
        URLS.ACCESS_KEYS,
        acGetAllAccessKeysBegin,
        acGetAllAccessKeysSuccess,
        acGetAllAccessKeysFailure
    )
}

// Get Access Key
const acGetAccessKeyBegin = () => ({ type: GET_ACCESS_KEY_BEGIN })
const acGetAccessKeySuccess = data => ({ type: GET_ACCESS_KEY_SUCCESS, payload: data })
const acGetAccessKeyFailure = err => ({ type: GET_ACCESS_KEY_FAILURE, payload: err })

/**
 * @description Dispatches a GET request to retrieve an access key.
 *
 * @author Maria Eduarda Franke
 */
export const acGetAccessKey = accessKeyId => {
    return dispatchFetchGet(
        `${URLS.ACCESS_KEYS}/${accessKeyId}`,
        acGetAccessKeyBegin,
        acGetAccessKeySuccess,
        acGetAccessKeyFailure
    )
}

// Post Access Key
const acPostAccessKeyBegin = () => ({ type: POST_ACCESS_KEY_BEGIN })
const acPostAccessKeySuccess = data => ({ type: POST_ACCESS_KEY_SUCCESS, payload: data })
const acPostAccessKeyFailure = err => ({ type: POST_ACCESS_KEY_FAILURE, payload: err })

/**
 * @description Dispatches a POST request to create an access key.
 *
 * @author Maria Eduarda Franke
 */
export const acPostAccessKey = applicationServiceId => {
    return dispatchFetchPost(
        URLS.ACCESS_KEYS,
        { applicationServiceId },
        acPostAccessKeyBegin,
        acPostAccessKeySuccess,
        acPostAccessKeyFailure
    )
}

// Put Access Key
const acPutAccessKeyBegin = () => ({ type: PUT_ACCESS_KEY_BEGIN })
const acPutAccessKeySuccess = data => ({ type: PUT_ACCESS_KEY_SUCCESS, payload: data })
const acPutAccessKeyFailure = err => ({ type: PUT_ACCESS_KEY_FAILURE, payload: err })

/**
 * @description Dispatches a PUT request to update an access key.
 *
 * @author Maria Eduarda Franke
 */
export const acPutAccessKey = accessKeyId => {
    return dispatchFetchPut(
        `${URLS.ACCESS_KEYS}/${accessKeyId}`,
        {},
        acPutAccessKeyBegin,
        acPutAccessKeySuccess,
        acPutAccessKeyFailure
    )
}